export default __webpack_public_path__ + "static/media/19_E92112-min.e76e5ce5.jpg";